let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iucz1")).then(() => parcelRequire('e5XXZ'));